import React, { useState } from "react";
import Sidebar from "../Navigations/Sidebar";
import SummaryBoard from "./SummaryBoard";
import DashboardHeader from "./DashboardHeader";
import usePageTitle from "../../hooks/usePageTitle";

const Dashboard: React.FC = () => {
  const [selectedPeriod, setSelectedPeriod] = useState<string>("1mth");
  const [loading, setLoading] = useState(false);

  usePageTitle("Dashboard");

  const handleRefresh = () => {
    setLoading(true);
  };

  const handlePeriodChange = (period: string) => {
    setSelectedPeriod(period);
  };

  return (
    <div className="app-layout">
      <Sidebar currentPage="/dashboard" />

      <div className="main-content dashboard-page">
        <DashboardHeader
          selectedPeriod={selectedPeriod}
          loading={loading}
          onRefresh={handleRefresh}
          onPeriodChange={handlePeriodChange}
        />
        <SummaryBoard 
          selectedPeriod={selectedPeriod}
          loading={loading}
          onRefresh={handleRefresh}
          onLoadingChange={setLoading}
          onPeriodChange={handlePeriodChange}
        />
      </div>
    </div>
  );
};

export default Dashboard;
